import React, { useState, useEffect } from "react";
// import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { apiRequest } from "../apiService/allApi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AbouImg from "../Assest/images/user-img.jpg";
import AbouImg1 from "../Assest/images/about-banner.jpg";
import AbouImg2 from "../Assest/images/cms-banner2.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
// import "./ProductDetails.css";

const images = [
  "https://swiperjs.com/demos/images/nature-1.jpg",
  "https://swiperjs.com/demos/images/nature-2.jpg",
  "https://swiperjs.com/demos/images/nature-3.jpg",
  "https://swiperjs.com/demos/images/nature-4.jpg",
];

const colors = [
  { id: 1, value: "#111827" }, // black
  { id: 2, value: "#0f766e" }, // green
  { id: 3, value: "#cbd5e1" }, // light gray
  { id: 4, value: "#dc2626" }, // red
  { id: 5, value: "#2563eb" }, // blue
  { id: 6, value: "#f59e0b" }, // yellow
];

const TruckIcon = () => (
  <svg viewBox="0 0 24 24">
    <rect x="1" y="3" width="15" height="13" />
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

const HomeIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const SilverIcon = () => (
  <svg viewBox="0 0 24 24">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const ReturnIcon = () => (
  <svg viewBox="0 0 24 24">
    <polyline points="17 1 21 5 17 9" />
    <path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" />
    <path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);

const CertifiedIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const WarrantyIcon = () => (
  <svg viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);


const features = [
  { text: "Fast Shipment", icon: TruckIcon },
  { text: "Easy Payment", icon: HomeIcon },
  { text: "Fine 925 Silver", icon: SilverIcon },
  { text: "Easy 30 Day Return", icon: ReturnIcon },
  { text: "Certified Stones", icon: CertifiedIcon },
  { text: "6-Month Warranty", icon: WarrantyIcon },
  { text: "Available in India Only", icon: LocationIcon },
];

const FacebookIcon = () => (
  <svg viewBox="0 0 64 64" width="32" height="32">
    <circle cx="32" cy="32" r="32" fill="#0965FE" />
    <path
      d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
      fill="white"
    />
  </svg>
);

const TwitterIcon = () => (
  <svg viewBox="0 0 64 64" width="32" height="32">
    <circle cx="32" cy="32" r="32" fill="#00aced" />
    <path
      d="M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6
      C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5
      c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3
      c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8
      c0,3.2,2.3,5.8,5.3,6.4
      c-0.6,0.1-1.1,0.2-1.7,0.2
      c0.8,2.6,3.3,4.5,6.1,4.6
      c-2.2,1.8-5.1,2.8-8.2,2.8
      c2.9,1.9,6.4,2.9,10.1,2.9
      c12.1,0,18.7-10,18.7-18.7
      C46,24.5,47.1,23.4,48,22.1z"
      fill="white"
    />
  </svg>
);

const RedditIcon = () => (
  <svg viewBox="0 0 64 64" width="32" height="32">
    <circle cx="32" cy="32" r="32" fill="#FF5700" />
    <path
      d="M21.3 35.2a3.2 3.2 0 1 0 6.4 0a3.2 3.2 0 0 0-6.4 0zm15.8 0a3.2 3.2 0 1 0 6.4 0a3.2 3.2 0 0 0-6.4 0z"
      fill="white"
    />
  </svg>
);

const WhatsappIcon = () => (
  <svg viewBox="0 0 64 64" width="32" height="32">
    <circle cx="32" cy="32" r="32" fill="#25D366" />
    <path
      d="M32 12c-11 0-20 9-20 20c0 3.5 0.9 6.8 2.6 9.7L12 52l10.6-2.8
      c2.8 1.5 6 2.3 9.4 2.3c11 0 20-9 20-20S43 12 32 12z"
      fill="white"
    />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 64 64" width="32" height="32">
    <circle cx="32" cy="32" r="32" fill="#0077B5" />
    <path
      d="M20.4 44h5.4V26.6h-5.4V44zM23.1 18a3.1 3.1 0 1 0 0 6.2a3.1 3.1 0 0 0 0-6.2z
      M39.5 26.2c-2.6 0-4.4 1.4-5.1 2.8v-2.4h-5.2V44h5.4v-8.6
      c0-2.3 0.4-4.5 3.2-4.5s2.8 2.6 2.8 4.6V44H46v-9.5
      c0-4.7-1-8.3-6.5-8.3z"
      fill="white"
    />
  </svg>
);



const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selected, setSelected] = useState(2);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [qty, setQty] = useState(1);

 const increaseQty = () => {
  if (product?.stock <= 0) {
    toast.error("❌ Product Out of Stock!");
    return;
  }

  if (qty >= product.stock) {
    toast.error("❌ Only limited stock available!");
    return;
  }

  setQty(prev => prev + 1);
};

const decreaseQty = () => {
  if (qty > 1) {
    setQty(prev => prev - 1);
  }
};

  // 🔹 ADD TO CART (sessionStorage)
const addToCart = () => {
  if (product?.stock <= 0) {
    toast.error("❌ Product Out of Stock!");
    return;
  }

  if (qty > product.stock) {
    toast.error("❌ Only limited stock available!");
    return;
  }

  let cart = JSON.parse(sessionStorage.getItem("cart")) || [];

  const existing = cart.find((item) => item._id === product._id);

  if (existing) {
    if (existing.qty + qty > product.stock) {
      toast.error("out of stock!");
      return;
    }
    existing.qty += qty;
  } else {
    cart.push({
      _id: product._id,
      name: product.title?.en,
      price: product.prices?.price,
      image: product.image?.[0],
      qty: qty,
      stock: product.stock,   // ✅ store stock
      color: selected,
    });
  }

  sessionStorage.setItem("cart", JSON.stringify(cart));
  window.dispatchEvent(new Event("cartUpdated"));
  toast.success("Product added to cart 🛒");
};


 useEffect(() => {
  // Scroll to top when component mounts
  window.scrollTo(0, 0);

  const fetchProduct = async () => {
    setLoading(true);
    setError(null);

    try {
      // ⚠️ LIST API CALL
      const res = await apiRequest("api/products", "GET");
      // console.log("API RESPONSE:", res);

      if (res?.data?.products?.length) {
        // 🔍 ID se product find karo
        const foundProduct = res.data.products.find(
          (item) => item._id === id || item.productId === id
        );

        if (foundProduct) {
          setProduct(foundProduct);

          // Filter similar products by category
          const similar = res.data.products.filter(
            (item) =>
              item.category?.name?.en === foundProduct.category?.name?.en &&
              item._id !== foundProduct._id
          );
          // console.log("Found Product Category:", foundProduct.category?.name?.en);
          // console.log("Similar Products:", similar);
          setSimilarProducts(similar);
        } else {
          setError("Product not found");
        }
      } else {
        setError("No products found");
      }
    } catch (e) {
      console.error("API ERROR:", e);
      setError("Failed to load product");
    } finally {
      setLoading(false);
    }
  };

  if (id) {
    fetchProduct();
  }
}, [id]);

  return (
    <>
      <div className="cover-bg-img">
        <div className="dz-bnr-inr-entry">
          <h1>Product Details</h1>
          <nav aria-label="breadcrumb" className="breadcrumb-row">
            <ul className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item">Product Details</li>
            </ul>
          </nav>
        </div>
      </div>
      <section className="py-lg-5 py-3 bg-light">
        <div className="container-fluid">
          <div className="product-details-box">
            <div className="row g-4">

              
              <div className="col-lg-4 col-md-6">
                <div className="">

                  <Swiper
                    navigation
                    thumbs={{ swiper: thumbsSwiper }}
                    modules={[Navigation, Thumbs]}
                    className="main-slider mb-3"
                  >
                    {product?.image?.map((img, i) => (
                      <SwiperSlide key={i}>
                        <img src={img} className="img-fluid rounded" alt={product?.title?.en} />
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  <Swiper
                    onSwiper={setThumbsSwiper}
                    spaceBetween={10}
                    slidesPerView={4}
                    watchSlidesProgress
                    modules={[Thumbs]}
                    className="thumb-slider"
                  >
                    {product?.image?.map((img, i) => (
                      <SwiperSlide key={i}>
                        <img src={img} className="img-fluid rounded thumb-img" alt={product?.title?.en} />
                      </SwiperSlide>
                    ))}
                  </Swiper>


                </div>
              </div>

              {/* RIGHT DETAILS SECTION */}
              <div className="col-lg-5 col-md-6">
                <div className="product-content p-0">
                  <h2>{product?.title?.en}</h2>
                  <small className="d-block">Sku:<b>{product?.sku}</b></small>
                  <span className="badge-xs">Stock:{product?.stock}</span>
                </div>
                <div className="product-card-main">
                  <div className="price">
                    <h2>₹{product?.prices?.price}</h2><del>₹{product?.prices?.mrp}</del>
                  </div>
                  <div className="proice">

                    <p>{product?.description?.en}</p>
                    <div className="color-wrapper">
                      <p className="color-title">Color</p>

                      <div className="color-options">
                        {colors.map((color) => (
                          <div
                            key={color.id}
                            className={`color-circle ${selected === color.id ? "active" : ""
                              }`}
                            onClick={() => setSelected(color.id)}
                          >
                            <span
                              className="inner-circle"
                              style={{ backgroundColor: color.value }}
                            ></span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="cart-wrapper">
                      <div className="qty-box">
                        <button onClick={decreaseQty}>−</button>
                        <span className="qty">{qty}</span>
                        <button onClick={increaseQty}>+</button>
                      </div>

                      <button
  className="add-cart-btn"
  onClick={addToCart}
  disabled={product?.stock <= 0}
>
  {product?.stock <= 0 ? "Out of Stock" : "Add to Cart"}
</button>
                    </div>

                    <div className="d-flex align-items-center mt-3">
                      <h6 className="mb-0 cate-title"><b>Category:</b></h6><p className="mb-0 mt-0"><a className="cate-link" href="javascript;void(0);">{product?.category?.name?.en}</a></p>
                    </div>

                    <div className="d-flex align-items-center mt-5">
                      <p className="mb-0 mt-0 call-text">Call Us To Order By Mobile Number:</p><h6 className="mb-0 cate-title text-danger"><b>+0044235234</b></h6>
                    </div>

                    <div className=" mt-2">
                      <h6 className="mb-0 cate-title"><b>Share your social network</b></h6><p className="mb-0 mt-0">For get lots of traffic from social network share this product</p>
                    </div>

                    <ul className="share-list">
                      <li className="share-item">
                        <button className="share-btn" aria-label="Facebook">
                          <FacebookIcon />
                        </button>
                      </li>

                      <li className="share-item">
                        <button className="share-btn" aria-label="Twitter">
                          <TwitterIcon />
                        </button>
                      </li>

                      <li className="share-item">
                        <button className="share-btn" aria-label="Reddit">
                          <RedditIcon />
                        </button>
                      </li>

                      <li className="share-item">
                        <button className="share-btn" aria-label="WhatsApp">
                          <WhatsappIcon />
                        </button>
                      </li>

                      <li className="share-item">
                        <button className="share-btn" aria-label="LinkedIn">
                          <LinkedInIcon />
                        </button>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="features-box">
                  <ul className="features-list">
                    {features.map((item, index) => (
                      <li className="feature-item" key={index}>
                        <span className="feature-icon">
                          <item.icon />
                        </span>
                        <p className="feature-text">{item.text}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <h2 className="relate">Related Products</h2>
          {similarProducts.length > 0 ? (
            <Swiper
              spaceBetween={20}
              slidesPerView={4}
              navigation
              modules={[Navigation]}
              breakpoints={{
                360: { slidesPerView: 2 },
                559: { slidesPerView: 3 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
              }}
              className="related-products-slider"
            >
              {similarProducts.map((item) => (
                <SwiperSlide key={item._id}>
                  <div className="product-card mb-3 group">
                    <div
                      className="product-image"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/product/${item._id}`)}
                    >
                      <img src={item.image?.[0]} alt={item.title?.en} />
                    </div>
                    <div className="product-content">
                      <h2
                        className="product-title"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(`/product/${item._id}`)}
                      >
                        {item.title?.en}
                      </h2>
                      <div className="product-footer">
                        <div className="price">
                          <span className="current">₹{item.prices?.price}</span>
                          <del className="old">₹{item.prices?.originalPrice}</del>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <p>No similar products found.</p>
          )}
        </div>
      </section>
      <ToastContainer />

    </>


  );
};

export default ProductDetails;